import { useEffect, useMemo } from "react";

import { type Message } from "shared/apiClient";
import { MessageType } from "shared/types";

import { CaptureEventType, useCaptureEvent } from "@/hooks";
import { type RoutingQuestionData } from "@/components/wizard/widgets/routingStep/hooks";

import { OffTopicPanel } from "./OffTopicPanel";

export interface OffTopicPanelContainerProps {
  message: Message | undefined | null;
}

export function OffTopicPanelContainer({
  message,
}: OffTopicPanelContainerProps) {
  const { captureEvent } = useCaptureEvent();

  useEffect(() => {
    if (message?.id) {
      captureEvent(CaptureEventType.USER_OFF_TOPIC_RENDERED, {
        messageId: message?.id,
        uuid: message?.id,
      });
    }
  }, [message]); // eslint-disable-line

  const { actions, content, title } = useMemo(() => {
    // TODO: Remove this once we transition off topic to conversation routing
    if (message?.message_type === MessageType.OFF_TOPIC) {
      return {
        content: message.text || "",
      };
    }

    if (message?.message_type === MessageType.ROUTING_QUESTION) {
      const questionData = (message.question_data || {}) as RoutingQuestionData;

      if (
        Array.isArray(questionData.analysis_callouts) &&
        questionData.analysis_callouts.length > 0
      ) {
        const { actions, content, title } = questionData.analysis_callouts[0];

        return { actions, content, title };
      }
    }

    return {
      actions: [],
      content: "",
      title: "",
    };
  }, [message]);

  return <OffTopicPanel actions={actions} content={content} title={title} />;
}
